import { useAnchorable } from '../../hooks/useAnchorable';

import { audioContainer } from './Audio.css';
import type { TPostAudioProps } from './Audio.types';

export const PostAudio = (props: TPostAudioProps) => {
  const { element } = props;
  const { attrs } = element;
  const { anchorAttributes } = useAnchorable(attrs);

  return (
    // Email audio links point to {{live_url}}#<id>, so the node id is the scroll target when no custom anchor is set.
    <div id={anchorAttributes.id ?? attrs.id} className={audioContainer}>
      <iframe
        src={attrs.data?.iframe_src}
        title="Post audio player"
        className="w-full h-[162px]"
        loading="lazy"
        allow="encrypted-media"
      />
    </div>
  );
};
